<template>
  <div class="mx-1">
    <div class="row">
      <div class="col-12">
        <div class="row ml-0">
          <h5 id="crewListInformationLabel" class="text-uppercase p-2" style="font-weight: bold">Embarkation/Disembarkation History</h5>
          <div class="ml-0 e-text-red" style="position: relative; top: 8px; font-size: 15px">({{ vessel?.name }})</div>
        </div>


        <div>
          <table class="w-100">
            <tr>
              <td class="w-15">Embark Date</td>
              <td class="w-30 p-2">
                <input type="date" name="" id="" v-model="start_date" class="form-control form-control-sm" :max="end_date">
<!--                <date-picker class="w-100" id = "date-picker" :lang = 'en' type="date" valueType="format" placeholder="Select Embark Date Range" range v-model="embark_date_range"></date-picker>-->
              </td>
              <td class="w-15">Disembark Date</td>
              <td class="w-30 p-2">
                <input type="date" name="" id="" v-model="end_date" class="form-control form-control-sm" :min="start_date">
<!--                <date-picker class="w-100" id = "date-picker" :lang = 'en' type="date" valueType="format" placeholder="Select Disembark Date Range" range v-model="disembark_date_range"></date-picker>-->
              </td>
              <td class="w-10">
                <button type="submit" class="btn btn-sm btn-primary" @click="setPage(1)">
                  Search
                </button>
              </td>
            </tr>
            <tr>
              <td class="w-15">Embark Country</td>
              <td class="w-30 p-2">
                <select-with-search
                  :key="dropdownInstance"
                  v-model="embark_country_id"
                  :current-selected-item-id="embark_country_id"
                  :key-item-value="'id'"
                  :key-display-text="'name'"
                  :items="[{
                      id : null,
                      name : '—— ALL COUNTRIES ——'
                    }].concat(sortedCountries)"
                  :element-class="'form-control w-auto form-control-sm'"
                />
              </td>
              <td class="w-15">Disembark Country</td>
              <td class="w-30 p-2">
                <select-with-search
                  :key="dropdownInstance"
                  v-model="disembark_country_id"
                  :current-selected-item-id="disembark_country_id"
                  :key-item-value="'id'"
                  :key-display-text="'name'"
                  :items="[{
                      id : null,
                      name : '—— ALL COUNTRIES ——'
                    }].concat(sortedCountries)"
                  :element-class="'form-control w-auto form-control-sm'"
                />
              </td>
              <td class="w-10">
                <button id="committeeReport" @click="resetFilter" class="w-auto e-btn e-btn-blue-gray force-white-all">
                  <font-awesome-icon class="mr-1" icon="filter"/>
                  Reset Filter
                </button>
              </td>
            </tr>
            <tr>
              <td class="w-15">Embark Port</td>
              <td class="w-30 p-2">
                <select-with-search
                  :key="dropdownInstance"
                  :disabled="!embark_ports.length"
                  v-model="embark_port_id"
                  :current-selected-item-id="embark_port_id"
                  :key-item-value="'id'"
                  :key-display-text="'name'"
                  :items="[{
                      id : null,
                      name : '—— ALL PORTS ——'
                    }].concat(embark_ports)"
                  :element-class="'form-control w-auto form-control-sm'"
                />
              </td>
              <td class="w-15">Disembark Port</td>
              <td class="w-30 p-2">
                <select-with-search
                  :key="dropdownInstance"
                  :disabled="!disembark_ports.length"
                  v-model="disembark_port_id"
                  :current-selected-item-id="disembark_port_id"
                  :key-item-value="'id'"
                  :key-display-text="'name'"
                  :items="[{
                      id : null,
                      name : '—— ALL PORTS ——'
                    }].concat(disembark_ports)"
                  :element-class="'form-control w-auto form-control-sm'"
                />
              </td>
              <td class="w-10">
                <div class="dropdown dropright" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                  <button id="committeeReport" v-if="crewEmbarkDisembarkHistory.length" aria-expanded="false" aria-haspopup="true" class="e-btn force-white-all"
                          data-toggle="dropdown" :disabled="loading" :class="loading ? 'e-btn-blue-gray cursor-not-allowed' : 'e-btn-primary'"
                  >
                    <font-awesome-icon class="mr-1" icon="download"/>
                    Download
                  </button>
                  <button v-else class="e-btn e-btn-blue-gray force-white-all" type="button" disabled style="cursor: not-allowed">
                    <font-awesome-icon class="mr-1" icon="download"/>
                    Download
                  </button>
                  <div aria-labelledby="committeeReport" class="dropdown-menu">
                    <button class="dropdown-item text-secondary font-weight-bolder" type="button" @click="downloadReport('xlsx')">
                      <font-awesome-icon icon="file-excel" size="sm"/>
                      Excel
                    </button>
                    <button class="dropdown-item text-secondary font-weight-bolder" type="button" @click="downloadReport('pdf')">
                      <font-awesome-icon icon="file-pdf" size="sm"/>
                      PDF
                    </button>
                  </div>

                </div>
              </td>
            </tr>
            <tr>
              <td class="w-15">Rank</td>
              <td class="w-30 p-2">
                <select-with-search
                  :key="dropdownInstance"
                  v-model="rank_id"
                  :current-selected-item-id="rank_id"
                  :key-item-value="'id'"
                  :key-display-text="'name'"
                  :items="[{
                      id : null,
                      name : '—— ALL RANKS ——'
                    }].concat(cmsRanks)"
                  :element-class="'form-control w-auto form-control-sm'"
                />
              </td>
              <td class="w-15"></td>
              <td class="w-30 p-2">

              </td>
            </tr>
          </table>
        </div>
        <div class="row no-gutters align-items-center justify-content-between">
          <div class="col-sm-auto pb-2 mr-2">
            <nav aria-label="...">
              <ul class="pagination text-smallest mb-0 pb-0">
                <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                  <button class="page-link" @click="setPage(1)">First</button>
                </li>

                <li v-for="page in paginationPages" :key="page" class="page-item"
                    :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                  <button class="page-link" @click="setPage(page)">{{ page }}</button>
                </li>

                <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                  <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <table id="history_table" class="table w-100 table-bordered table-responsive">
          <thead>
          <tr>
            <th class="align-middle text-center only-border-top only-border-bottom only-border-left" scope="col" style="width: 1%;">#</th>
            <th class="align-middle text-center only-border-top only-border-bottom" scope="col" style="width: 15%;">NAME</th>
            <th class="align-middle text-center only-border-top only-border-bottom" style="width: 15%" scope="col">RANK</th>
            <th class="align-middle text-center only-border-top only-border-bottom" style="width: 7%" scope="col">NATIONALITY</th>
            <th class="align-middle text-center only-border-top only-border-bottom only-border-right" style="width: 15%" scope="col">MANNING</th>
            <th class="align-middle text-center only-border-top only-border-bottom only-border-left" style="width: 10%" scope="col">EMBARK DATE</th>
            <th class="align-middle text-center only-border-top only-border-bottom" style="width: 5%" scope="col">PORT</th>
            <th class="align-middle text-center only-border-top only-border-bottom only-border-right" style="width: 5%" scope="col">COUNTRY</th>
            <th class="align-middle text-center only-border-top only-border-bottom only-border-left" style="width: 10%" scope="col">DISEMBARK DATE</th>
            <th class="align-middle text-center only-border-top only-border-bottom" style="width: 5%" scope="col">PORT</th>
            <th class="align-middle text-center only-border-top only-border-bottom only-border-right" style="width: 5%" scope="col">COUNTRY</th>
            <th class="align-middle text-center only-border-top only-border-bottom only-border-right only-border-left" style="width: 25%" scope="col">REASON</th>
          </tr>
          </thead>
          <tbody>
          <template v-if="loading">
            <tr>
              <td colspan="100%">
                <app-loading/>
              </td>
            </tr>
          </template>
          <template v-else>
            <template v-if="crewEmbarkDisembarkHistory.length === 0">
              <tr>
                <td colspan="100%" class="align-middle text-center font-weight-bold bg-secondary text-white">NO RESULTS FOUND</td>
              </tr>
            </template>
            <template>
              <tr v-for="(crew,index) in crewEmbarkDisembarkHistory">
                <td class="align-middle text-center">{{ pagination.from + index }}</td>
                <td class="align-middle text-center text-uppercase">{{crew.name.toUpperCase()}}</td>
                <td class="align-middle text-center text-uppercase">{{crew.rank.toUpperCase()}}</td>
                <td class="align-middle text-center text-uppercase">{{crew.nationality }}</td>
                <td class="align-middle text-center text-uppercase only-border-right">{{crew.manning }}</td>
                <td class="align-middle text-center text-uppercase only-border-left">
                  {{crew?.formatted_embark_date  }}
                </td>
                <td class="align-middle text-center text-uppercase">{{crew.start_port }}</td>
                <td class="align-middle text-center text-uppercase only-border-right">{{crew.start_port_country }}</td>
                <td class="align-middle text-center text-uppercase only-border-left">
                  {{crew?.formatted_disembark_date }}
                </td>
                <td class="align-middle text-center text-uppercase">{{crew.end_port }}</td>
                <td class="align-middle text-center text-uppercase only-border-right">{{crew.end_port_country }}</td>
                <td class="align-middle text-center text-uppercase only-border-left">{{crew.end_reason }}</td>
              </tr>
            </template>

          </template>

          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import ExperienceUi from "@/components/crew/experience/ExperienceUi.vue";
import {permissionMixin} from "@/mixins/permissionMixins";
import en from "vue2-datepicker/locale/es/en";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import SelectWithSearch from "@/components/common/SelectWithSearch.vue";
import Table from "@/components/layouts/Table.vue";
import AppLoading from "@/components/elements/AppLoading.vue";
import {AlertService} from "@/services/AlertService";
import {CrewService} from "@/services/CrewService";
export default {
  name: "VesselEmbarkDisembarkHistory",
  mixins:[permissionMixin, PaginationMixin],
  components:{AppLoading, Table, SelectWithSearch, 'experience-ui':ExperienceUi, DatePicker},
  data(){
    return {
      loading: false,
      vessel_id : this.$route.params.id,
      embark_port_id : null,
      embark_country_id : null,
      disembark_port_id : null,
      disembark_country_id : null,
      // embark_date_range : null,
      // disembark_date_range: null,
      start_date: null,
      end_date: null,
      rank_id: null,
      page : 1,
      per_page : 20,
      dropdownInstance : 0,
      file_selected: null,
    }
  },
  methods : {
    ...mapActions([
      'getCrewEmbarkDisembarkHistory',
      'getCmsCountries',
      'getCmsPorts',
      'getCmsRanks',
      'getVesselDetail',
    ]),
    async setPage(page = 1) {
      this.loading = true;
      this.pagination.currentPage = page;
      this.page = page
      await this.getCrewEmbarkDisembarkHistory(this.request);
      this.loading = false;
    },
    async resetFilter() {
      this.dropdownInstance++;
      this.loading = true;
      this.embark_port_id = null;
      this.embark_country_id = null;
      this.disembark_port_id = null;
      this.disembark_country_id = null;
      // this.embark_date_range = null;
      // this.disembark_date_range = null;
      this.start_date = null;
      this.end_date = null;
      this.rank_id = null;
      this.page = 1;
      this.file_selected = null;
      await this.getCrewEmbarkDisembarkHistory(this.request);
      this.loading = false;
    },
    async downloadReport(fileType){
      this.file_selected = fileType;
      swal.fire({
        'title': `LOADING...`,
        text: `Please wait while the system generates the report in ${fileType === 'pdf' ? 'PDF' : 'EXCEL'} format.`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      await this.getCrewEmbarkDisembarkHistory(this.request);
      const crew_info = {
        file_type: fileType,
        data: this.crewEmbarkDisembarkHistory,
        rank_id : this.rank_id,
        embark_port_id : this.embark_port_id,
        embark_country_id : this.embark_country_id,
        disembark_port_id : this.disembark_port_id,
        disembark_country_id : this.disembark_country_id,
        start_date : this.start_date === null ? null : this.start_date,
        end_date : this.end_date === null ? null : this.end_date,
      };

      const response = await CrewService.exportCrewEmbarkDisembarkHistory(crew_info);

      const blob = new Blob([response], { type: fileType === "pdf" ? "application/pdf" : "application/vnd.ms-excel" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Crew_Embark_Disembark_History_${Date.now()}.${fileType}`;
      link.click();
      URL.revokeObjectURL(link.href);

      swal.close();
      this.loading = true;
      this.file_selected = null;
      await this.getCrewEmbarkDisembarkHistory(this.request);
      this.loading = false;
    },
  },
  async created() {
    swal.fire({
      'title':'ESTABLISHING CONNECTION TO CMS',
      allowEscapeKey:false,
      allowOutsideClick:false,
      allowEnterKey:false
    })
    swal.showLoading()
    await this.getVesselDetail(this.$route.params.id);
    await this.getCmsCountries();
    await this.getCmsPorts();
    await this.getCmsRanks();
    await this.getCrewEmbarkDisembarkHistory(this.request);
    // this.crews= response.crews
    swal.close();
  },
  computed:{
    ...mapGetters([
      'crewEmbarkDisembarkHistory',
      'cmsCountries',
      'cmsPorts',
      'cmsRanks',
      'vessel',
    ]),
    sortedCountries() {
      return this.cmsCountries.sort((a, b) => a.name.localeCompare(b.name));
    },
    embark_ports() {
      const filtered = this.cmsPorts.filter(
        port => port.country_id === this.embark_country_id
      )

      return [
        ...new Map(filtered.map(port => [port.name, port])).values()
      ].sort((a, b) => a.name.localeCompare(b.name));
    },
    disembark_ports() {
      const filtered = this.cmsPorts.filter(
        port => port.country_id === this.disembark_country_id
      )

      return [
        ...new Map(filtered.map(port => [port.name, port])).values()
      ].sort((a, b) => a.name.localeCompare(b.name));
    },
    en() {
      return en
    },
    request() {
      return {
        vessel_id : this.$route.params.id,
        rank_id : this.rank_id,
        embark_port_id : this.embark_port_id,
        embark_country_id : this.embark_country_id,
        disembark_port_id : this.disembark_port_id,
        disembark_country_id : this.disembark_country_id,
        start_date : this.start_date === null ? null : this.start_date,
        end_date : this.end_date === null ? null : this.end_date,
        // embark_date_from : this.embark_date_range === null ? null : this.embark_date_range[0],
        // embark_date_to : this.embark_date_range === null ? null : this.embark_date_range[1],
        // disembark_date_from : this.disembark_date_range === null ? null : this.disembark_date_range[0],
        // disembark_date_to : this.disembark_date_range === null ? null : this.disembark_date_range[1],
        page : this.page,
        per_page : 20,
        file_selected : this.file_selected,
      }
    }
  }
}
</script>

<style scoped>
#history_table tr td {
  padding: 5px;
}

.only-border-top {
  border-top: 1px solid #000 !important;
}

.only-border-left {
  border-left: 1px solid #000 !important;
}

.only-border-right {
  border-right: 1px solid #000 !important;
}

.only-border-bottom {
  border-bottom: 1px solid #000 !important;
}


</style>
